// extracted by mini-css-extract-plugin
export default {"link":"CallAlert_link__0bkTG","pulse2":"CallAlert_pulse2__yDWhi","phoneIcon":"CallAlert_phoneIcon__3Nz8T"};